import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map, filter, dropRight,
} from 'lodash';
import {
  FileInput, Input, Select, SearchSelect, Checkbox, Textarea,
  Option,
} from '../../../../../components/base';
import {
  FINANCE_CASH_JOURNAL_FORM_FIELDS,
} from '../../../../../constants/finance/finance.constant';
import ListForm from '../../../../../components/ListForm/ListForm.component';

export default function CashJournalFormHeader(props) {
  const {
    form, coa, onFormChange, isDebit, onSearchUnit,
    isReconciliation, user,
  } = props;
  const { prm_school_units_id: unit_id } = user;
  const { user_group } = user;
  const { permissions } = user_group;
  const { value } = form;
  const { tipe = 0, is_posted = false } = value;
  let fields = FINANCE_CASH_JOURNAL_FORM_FIELDS;
  const journalType = filter(fields, o => o.name === 'type');
  const formType = filter(fields, o => o.name === 'tipe');
  const dateSelector = filter(fields, o => o.name === 'date');
  const unitSelector = filter(fields, o => o.name === 'unit');

  dateSelector[0].disabled = true;

  if (!isReconciliation) {
    if (permissions.includes('backdate_journal') || ((unit_id === 94 || unit_id === 1) && !is_posted)) {
      dateSelector[0].disabled = false;
    }
    if (!isDebit) {
      formType[0].data = [
        { label: 'Standard', value: '1' },
      ];
    } else {
      formType[0].data = [
        { label: 'Standard', value: '1' },
        { label: 'Rekonsiliasi', value: '2' },
      ];
    }
    journalType[0].disabled = false;
    formType[0].disabled = false;
    unitSelector[0].disabled = false;
  } else {
    journalType[0].disabled = true;
    formType[0].disabled = true;
    dateSelector[0].disabled = true;
    formType[0].data = [
      { label: 'Rekonsiliasi', value: '2' },
    ];
    unitSelector[0].disabled = true;
  }


  if (tipe === '2') {
    unitSelector[0].label = (isDebit) ? 'Unit Sumber' : 'Unit Tujuan';
    unitSelector[0].handleSearchContent = onSearchUnit;
    unitSelector[0].async = true;
    unitSelector[0].disabled = isReconciliation;
    fields = filter(fields, field => field.name !== 'pos');
  } else {
    fields = filter(fields, o => o.name !== 'unit');
  }

  return (
    <ListForm
      form={form}
      coa={coa}
      formFields={fields}
      onFormChange={onFormChange}
    />
  );
}


CashJournalFormHeader.propTypes = {
  form: PropTypes.object,
  coa: PropTypes.object,
  onFormChange: PropTypes.func,
  isDebit: PropTypes.bool,
  onSearchUnit: PropTypes.func,
  isReconciliation: PropTypes.bool,
  user: PropTypes.object,
};

CashJournalFormHeader.defaultProps = {
  form: {},
  coa: {},
  onFormChange: noop,
  isDebit: false,
  onSearchUnit: noop,
  isReconciliation: false,
  user: {},
};
